












import { Component, Vue, Prop } from "vue-property-decorator";
import CustomTransfer from "../customMobans/customTransferCmp.vue";
@Component({
  components: {
    CustomTransfer
  }
})
export default class LiangbiaoCmp extends Vue {
  @Prop()
  private liangbiao: any;
}
